(function () {
    let isMobile = window.matchMedia('(max-width:1023px)').matches;
    if (isMobile && (location.pathname == '/collections/sneakers-mens' || location.pathname == '/collections/womens-sneakers')) {
        function waitForEle(predicate, success, error) {
            var int = setInterval(function () {
                if (predicate()) {
                    clearInterval(int);
                    int = null;
                    success();
                }
            }, 33);
            setTimeout(function () {
                if (int !== null) {
                    clearInterval(int);
                    if (typeof (error) === 'function') {
                        error();
                    }
                }
            }, 30000);
        }

        var bnnroneHtm = `<div class="oc32Banner oc32One"><h4>Italian Calfskin</h4><img src="https://cdn-3.convertexperiments.com/uf/10041888/10042733/oc32One.jpeg" alt=""><p>Discover quality in every step with buttery Italian calfskin leather, meticulously handcrafted and hand-stitched for enduring quality.</p></div>`;

        var bannrTwoHtm = `<div class="oc32Banner oc32Otwo"> <h4>Built to last</h4> <img src="https://cdn-3.convertexperiments.com/uf/10041888/10042733/oc32three.jpg" alt=""> <p>Our leather sneakers with robust rubber soles are meticulously crafted to blend timeless style with unparalleled durability. Designed for those who value both comfort and longevity, these sneakers are a testament to superior craftsmanship and quality materials.</p> </div>`;

        waitForEle(function () {
            return $('.product-collection .product-collection__product').length > 1;
        }, function () {
            $('body').addClass('oc32');
            $('.product-collection .product-collection__product').eq(0).after(bnnroneHtm);
        });

        waitForEle(function () {
            return $('.product-collection .product-collection__product').length > 3;
        }, function () {
            $('.product-collection .product-collection__product').eq(3).after(bannrTwoHtm);
        });

        waitForEle(function () {
            return $('.product-collection .product-collection__product').length > 5;
        }, function () {
            $('.product-collection .product-collection__product').eq(5).after(bnnrThreeHtm);
        });
    }
})();